import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const { t } = useLanguage();
  return (
    <footer
      data-testid="main-footer"
      className="border-t border-zinc-800 bg-[#09090b] mt-24"
    >
      <div className="px-6 md:px-12 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="font-display text-3xl md:text-4xl tracking-wider">
            BRÄNNINGER
          </div>
          <div className="text-xs tracking-[0.3em] text-zinc-500 mt-1 font-mono">
            ÅKERI &amp; LOGISTIK AB
          </div>
          <p className="mt-6 text-zinc-400 max-w-md">{t.footer.tagline}</p>
        </div>

        <div>
          <div className="text-xs tracking-[0.25em] uppercase text-zinc-500 mb-4">
            {t.contact.title}
          </div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li className="flex items-start gap-2">
              <MapPin size={14} className="mt-1 text-[#ff5a00] shrink-0" />
              <span>{t.contact.address}</span>
            </li>
            <li className="flex items-start gap-2">
              <Phone size={14} className="mt-1 text-[#ff5a00] shrink-0" />
              <a
                href="tel:+46732008960"
                className="hover:text-[#ff5a00] transition-colors"
              >
                0732 00 89 60
              </a>
            </li>
            <li className="flex items-start gap-2">
              <Mail size={14} className="mt-1 text-[#ff5a00] shrink-0" />
              <a
                href="mailto:michael@mbakeri.se"
                className="hover:text-[#ff5a00] transition-colors break-all"
              >
                michael@mbakeri.se
              </a>
            </li>
            <li className="pt-2 mt-2 border-t border-zinc-800 text-xs font-mono text-zinc-500 tracking-widest">
              {t.contact.org_label}: {t.contact.org_no}
            </li>
          </ul>
        </div>

        <div>
          <div className="text-xs tracking-[0.25em] uppercase text-zinc-500 mb-4">
            {t.nav.home}
          </div>
          <ul className="space-y-3 text-sm text-zinc-300">
            <li>
              <Link to="/team" className="hover:text-[#ff5a00] transition-colors">
                {t.nav.team}
              </Link>
            </li>
            <li>
              <Link to="/gallery" className="hover:text-[#ff5a00] transition-colors">
                {t.nav.gallery}
              </Link>
            </li>
            <li>
              <Link to="/quote" className="hover:text-[#ff5a00] transition-colors">
                {t.nav.quote}
              </Link>
            </li>
            <li>
              <Link to="/admin" className="hover:text-[#ff5a00] transition-colors text-zinc-500">
                {t.nav.admin}
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-800 px-6 md:px-12 lg:px-16 py-6 flex flex-col md:flex-row gap-2 justify-between text-xs text-zinc-500 font-mono">
        <div>© {new Date().getFullYear()} BRÄNNINGER ÅKERI OCH LOGISTIK AB · {t.contact.org_label} 556712-0208</div>
        <div>{t.footer.rights}</div>
      </div>
    </footer>
  );
};
